
import { copyToClipboard } from 'quasar'
import { Component, Prop, Vue } from 'vue-property-decorator'

import PagoEfectivoModel from '../models/PagoEfectivo'

import EButton from './Button.vue'
import EPaymentInfo from './PaymentInfo.vue'

@Component({
  components: {
    EButton,
    EPaymentInfo,
  },
})
export default class PagoEfectivo extends Vue {
  @Prop({ required: true }) readonly pagoEfectivo!: PagoEfectivoModel

  copied = false;

  get isInstructionsVisible(): boolean {
    return this.pagoEfectivo.instructions.filter(Boolean).length > 0
  }

  private async copyCipCode() {
    try {
      await copyToClipboard(this.pagoEfectivo.cipCode)

      this.copied = true
      this.$emit('copy')
      setTimeout(() => { this.copied = false }, 1100)
    } catch (err) {
      console.error(err)
    }
  }
}
